import { Form, Spin, Tabs } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { getIdentifiers } from "../../api";
import { useTranslation } from "react-i18next";
import ChangePassword from "./ChangePassword";
import UpdatePhone from "./UpdatePhone";
import UpdateEmail from "./UpdateEmail";
import UpdateFacebook from "./UpdateFacebook";
import UpdateGoogle from "./UpdateGoogle";
import UpdateApple from "./UpdateApple";

const SigninInfo = () => {
  const { t } = useTranslation(["common", "notification"]);
  const [loaded, setLoaded] = useState<boolean>(false);
  const [phoneIdentifier, setPhoneIdentifier] = useState<any>(null);
  const [emailIdentifier, setEmailIdentifier] = useState<any>(null);
  const [appleIdentifier, setAppleIdentifier] = useState<any>(null);
  const [facebookIdentifier, setFacebookIdentifier] = useState<any>(null);
  const [googleIdentifier, setGoogleIdentifier] = useState<any>(null);
  const [canUnlink, setCanUnlink] = useState<boolean>(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const resIdentifiers = await getIdentifiers();
    if (resIdentifiers.status === "success") {
      setPhoneIdentifier(
        resIdentifiers.data.find(
          (identifier: any) => identifier.identifier_source === "phone"
        )
      );
      setEmailIdentifier(
        resIdentifiers.data.find(
          (identifier: any) => identifier.identifier_source === "email"
        )
      );
      setAppleIdentifier(
        resIdentifiers.data.find(
          (identifier: any) => identifier.identifier_source === "apple"
        )
      );
      setFacebookIdentifier(
        resIdentifiers.data.find(
          (identifier: any) => identifier.identifier_source === "facebook"
        )
      );
      setGoogleIdentifier(
        resIdentifiers.data.find(
          (identifier: any) => identifier.identifier_source === "google"
        )
      );
      setCanUnlink(
        resIdentifiers.data.reduce((prev: number, cur: any) => {
          return prev + (cur.status === "verified" ? 1 : 0);
        }, 0) > 1
      );
    }
    setTimeout(() => {
      setLoaded(true);
    }, 500);
  };

  const reloadIdentifiers = async () => {
    await fetchData();
  };

  if (!loaded) {
    return (
      <Spin
        size="large"
        indicator={<LoadingOutlined spin />}
        style={{ width: "100%" }}
      />
    );
  }

  return (
    <>
      <Tabs
        defaultActiveKey="1"
        style={{
          borderRadius: "8px",
          padding: "0 16px 16px 16px",
          marginBottom: "16px",
          backgroundColor: "white",
          overflow: "hidden",
        }}
        className="shadow"
      >
        <Tabs.TabPane tab={t("common:Thông tin đăng nhập")} key="1">
          <Form layout="vertical">
            <UpdatePhone
              reload={reloadIdentifiers}
              identifier={phoneIdentifier}
              canUnlink={canUnlink}
            />
            <UpdateEmail
              reload={reloadIdentifiers}
              identifier={emailIdentifier}
              canUnlink={false}
            />
            {/* <UpdateFacebook reload={reloadIdentifiers} identifier={facebookIdentifier} canUnlink={canUnlink} /> */}
            <UpdateGoogle
              reload={reloadIdentifiers}
              identifier={googleIdentifier}
              canUnlink={canUnlink}
            />
            <UpdateApple
              reload={reloadIdentifiers}
              identifier={appleIdentifier}
              canUnlink={canUnlink}
            />
          </Form>
        </Tabs.TabPane>
      </Tabs>
      {phoneIdentifier || emailIdentifier ? (
        <ChangePassword
          phone={
            phoneIdentifier && phoneIdentifier.status === "verified"
              ? phoneIdentifier.identifier_value
              : ""
          }
          email={
            emailIdentifier && emailIdentifier.status === "verified"
              ? emailIdentifier.identifier_value
              : ""
          }
        />
      ) : null}
    </>
  );
};

export default SigninInfo;
